import { ListContentIsland } from '@razz-team/ui-web';
import { useVaultQuery } from '../../../api/vaults';
import { CurrencyRateListItem } from '../../ListItem/CurrencyRateListItem';
import { useBalanceRate } from '../../../api/transfers';

export function VaultExchangeRate({ vaultId }: { vaultId: string }) {
  const vaultQuery = useVaultQuery({ vaultId });
  const balanceRate = useBalanceRate(vaultQuery.data?.balance);

  return (
    <ListContentIsland>
      <CurrencyRateListItem rate={balanceRate?.rate} currency={vaultQuery.data?.balance.currency} />
    </ListContentIsland>
  );
}
